import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';
import { __, isRTL } from '@wordpress/i18n';
import { Icon, chevronLeft, chevronRight } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import { useNavigationContext } from '../context';
import { MenuBackButtonUI } from '../styles/navigation-styles';

function NavigationBackButton(_ref, ref) {
  var _navigationTree$getMe;

  var backButtonLabel = _ref.backButtonLabel,
      className = _ref.className,
      href = _ref.href,
      onClick = _ref.onClick,
      parentMenu = _ref.parentMenu;

  var _useNavigationContext = useNavigationContext(),
      setActiveMenu = _useNavigationContext.setActiveMenu,
      navigationTree = _useNavigationContext.navigationTree;

  var classes = classnames('components-navigation__back-button', className);
  var parentMenuTitle = (_navigationTree$getMe = navigationTree.getMenu(parentMenu)) === null || _navigationTree$getMe === void 0 ? void 0 : _navigationTree$getMe.title;

  var handleOnClick = function handleOnClick(event) {
    if (typeof onClick === 'function') {
      onClick(event);
    }

    var animationDirection = isRTL() ? 'left' : 'right';

    if (parentMenu && !event.defaultPrevented) {
      setActiveMenu(parentMenu, animationDirection);
    }
  };

  var icon = isRTL() ? chevronRight : chevronLeft;
  return createElement(MenuBackButtonUI, {
    className: classes,
    href: href,
    isTertiary: true,
    ref: ref,
    onClick: handleOnClick
  }, createElement(Icon, {
    icon: icon
  }), backButtonLabel || parentMenuTitle || __('Back'));
}

export default forwardRef(NavigationBackButton);
//# sourceMappingURL=index.js.map